(function () {
  const TARGET_VARIANT_ID = 57132704956797;
  const UNIT_PRICE = 39.00;

  function formatMoneyEur(value) {
    const fixed = Number(value).toFixed(2);
    const parts = fixed.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];

    const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + grouped + ',' + decimalPart;
  }

  function getDiscountAmount(qty) {
    const fixedDiscounts = {
      4: 57.00,
      5: 71.25,
      6: 85.50,
      7: 99.75,
      8: 153.00,
      9: 172.15
    };

    if (fixedDiscounts[qty] !== undefined) {
      return fixedDiscounts[qty];
    }

    if (qty >= 10) {
      return qty * UNIT_PRICE * 0.49;
    }

    return 0;
  }

  function buildPriceMarkup(oldTotal, newTotal) {
    return `
      <compare-at-price class="text-subdued ai-cart-old-price">
        <span class="sr-only">Įprasta kaina</span>${formatMoneyEur(oldTotal)}
      </compare-at-price>
      <sale-price class="text-subdued ai-cart-new-price">
        <span class="sr-only">Pardavimo kaina</span>${formatMoneyEur(newTotal)}
      </sale-price>
    `;
  }

  function getTargetLineItems() {
    return Array.from(document.querySelectorAll('line-item.line-item')).filter((lineItem) => {
      const qtyInput = lineItem.querySelector('input.quantity-input[data-line-key]');
      if (!qtyInput) return false;

      const lineKey = qtyInput.getAttribute('data-line-key') || '';
      return lineKey.startsWith(String(TARGET_VARIANT_ID) + ':');
    });
  }

  function updateTargetLine(lineItem) {
    const qtyInput = lineItem.querySelector('input.quantity-input[data-line-key]');
    if (!qtyInput) return;

    const qty = parseInt(qtyInput.value, 10);
    if (!qty || qty < 1) return;

    const oldTotal = UNIT_PRICE * qty;
    const discountAmount = getDiscountAmount(qty);
    const newTotal = Math.max(0, oldTotal - discountAmount);

    const priceList = lineItem.querySelector('price-list');
    if (!priceList) return;

    const nativeSale = priceList.querySelector('sale-price:not(.ai-cart-new-price)');
    const nativeCompare = priceList.querySelector('compare-at-price:not(.ai-cart-old-price)');

    priceList.querySelectorAll('.ai-cart-old-price, .ai-cart-new-price').forEach((el) => el.remove());

    if (discountAmount > 0) {
      if (nativeSale) nativeSale.style.display = 'none';
      if (nativeCompare) nativeCompare.style.display = 'none';
      priceList.insertAdjacentHTML('beforeend', buildPriceMarkup(oldTotal, newTotal));
    } else {
      if (nativeSale) nativeSale.style.display = '';
      if (nativeCompare) nativeCompare.style.display = 'none';
    }
  }

  function updateAllTargetLines() {
    const lines = getTargetLineItems();
    lines.forEach(updateTargetLine);
  }

  function queueUpdateSequence() {
    const delays = [50, 200, 500, 900, 1400];

    delays.forEach((delay) => {
      setTimeout(updateAllTargetLines, delay);
    });
  }

  function bindAjaxHooks() {
    if (window.roketMicroFuseAjaxBound) return;
    window.roketMicroFuseAjaxBound = true;

    const originalFetch = window.fetch;
    window.fetch = function () {
      return originalFetch.apply(this, arguments).then((response) => {
        try {
          const url = arguments[0] && arguments[0].toString ? arguments[0].toString() : '';

          if (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear') ||
            url.includes('/cart.js') ||
            url.includes('/cart?section_id=')
          ) {
            queueUpdateSequence();
          }
        } catch (e) {}

        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._roketCartUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', () => {
        try {
          const url = this._roketCartUrl || '';

          if (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear') ||
            url.includes('/cart.js') ||
            url.includes('/cart?section_id=')
          ) {
            queueUpdateSequence();
          }
        } catch (e) {}
      });

      return originalSend.apply(this, arguments);
    };
  }

  function bindEvents() {
    document.addEventListener('change', function (event) {
      const input = event.target.closest('input.quantity-input');
      if (!input) return;
      queueUpdateSequence();
    });

    document.addEventListener('input', function (event) {
      const input = event.target.closest('input.quantity-input');
      if (!input) return;
      queueUpdateSequence();
    });

    document.addEventListener('cart:updated', queueUpdateSequence);
    document.addEventListener('cart:refresh', queueUpdateSequence);
    document.addEventListener('DOMContentLoaded', queueUpdateSequence);
    window.addEventListener('load', queueUpdateSequence);
  }

  bindAjaxHooks();
  bindEvents();
  queueUpdateSequence();
})();